import { z } from 'zod/v4-mini';
import { ZodTaskMessageLocation } from './TaskMessageLocation.js';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
export const ZodTaskNote = matchingZodObject({
    text: z.string(),
    location: z.optional(ZodTaskMessageLocation),
});
export const ZodTaskMessage = matchingZodObject({
    text: z.string(),
    source: z.string(),
    location: z.optional(ZodTaskMessageLocation),
    notes: z.optional(z.array(ZodTaskNote)),
});
//# sourceMappingURL=TaskMessage.js.map